import JassEnum from './enum';

/**
 * type version
 */
export default class JassVersion extends JassEnum {}
